// @flow
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actions as QuoteStepActions } from '../duck';
import { actions as ShoppingCartActions } from '../../../shopping-cart/duck';
import { actions as BagActions } from '../../../bag/duck';
import { actions as CheckoutStepActions } from '../../CheckoutStep/duck';
import { actions as AlertActions } from '../../../alert/duck';
import QuoteStep from '../components/QuoteStep';
import { push } from 'react-router-redux';

import type { RootState } from '../../..';

function mapStateToProps(state: RootState) {
  return {
    user: state.auth.user,
    authenticated: state.auth.authenticated,
    locale: state.locale,
    localValues: state.localValues,
    chosenVariants: state.abTest.chosenVariants,
    appliedCoupon: state.newOrder.quoteStep.appliedCoupon,
    isLoadingForecast: state.newOrder.quoteStep.isLoadingForecast,
    forecast: state.newOrder.quoteStep.forecast,
    forecastError: state.newOrder.quoteStep.forecastError,
    isPostingMissingSum: state.newOrder.quoteStep.isPostingMissingSum,
    missingSum: state.newOrder.quoteStep.missingSum,
    postMissingSumError: state.newOrder.quoteStep.postMissingSumError,
    isFetchingProducts: state.newOrder.quoteStep.isFetchingProducts,
    // relatedProducts: state.newOrder.quoteStep.relatedProducts,
    fetchProductsError: state.newOrder.quoteStep.fetchProductsError,    
    isFetchingCart: state.shoppingCart.isFetchingCart,
    shoppingCart: state.shoppingCart.shoppingCart,
    virtualShoppingCart: state.shoppingCart.virtualShoppingCart,
    virtualShoppingCartInitialized: state.shoppingCart.virtualShoppingCartInitialized,
    isPostingToCart: state.shoppingCart.isPostingToCart,
    isPostingCartItem: state.shoppingCart.isPostingCartItem,
    postCartItemSuccess: state.shoppingCart.postCartItemSuccess,
    postCartItemError: state.shoppingCart.postCartItemError,
    isEditingItem: state.shoppingCart.isEditingItem || state.bag.isEditingItem,
    editItemError: state.shoppingCart.editItemError || state.bag.editItemError,
    isDeletingItem: state.shoppingCart.isDeletingItem || state.bag.isDeletingItem,
    deleteItemError: state.shoppingCart.deleteItemError || state.bag.deleteItemError,
    isFetchingBag: state.bag.isFetchingBag,
    bag: state.bag.bag,
    virtualBag: state.bag.virtualBag,
    fetchBagError: state.bag.fetchBagError,
    isPostingBag: state.bag.isPostingBag,
    postBagItemError: state.bag.postBagItemError,
  };
}

function mapDispatchToProps(dispatch: Function) {
  return bindActionCreators({
    ...QuoteStepActions,
    ...ShoppingCartActions,
    ...BagActions,
    ...AlertActions,
    goToRedirect: (route: string) => push(route),
    checkoutFetchCheckoutDataSuccess: CheckoutStepActions.fetchCheckoutDataSuccess,
    checkoutFetchAppliedCouponSuccess: CheckoutStepActions.fetchAppliedCouponSuccess,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(QuoteStep);



// WEBPACK FOOTER //
// ./src/modules/new-order/QuoteStep/containers/QuoteStepContainer.jsx